import axios from 'axios';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080/api/v1', 
});

// Request interceptor to attach the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
    const reqUrl = config.url || '';
    const isAuthReq = reqUrl.includes('login') || reqUrl.includes('register') || reqUrl.includes('auth') || reqUrl.includes('forgot-password');
    if (token && !isAuthReq) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const status = error.response.status;
      const reqUrl = originalRequest?.url || '';
      const isAuthEndpoint = reqUrl.includes('login') || reqUrl.includes('register') || reqUrl.includes('auth') || reqUrl.includes('forgot-password');

      if (status === 401 && !originalRequest._retry && !isAuthEndpoint) {
        // Prevent infinite loops
        originalRequest._retry = true;

        try {
          // Get current token or refresh token
          const currentToken = localStorage.getItem('token') || localStorage.getItem('userToken') || sessionStorage.getItem('userToken');
          const refreshToken = Cookies.get('refreshToken') || currentToken;

          if (!refreshToken) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('userToken');
            sessionStorage.removeItem('userToken');
            window.location.href = '/signin';
            return Promise.reject(error);
          }

          // Attempt to refresh the token
          const refreshBase = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/api\/v1\/?$/, '');
          const response = await axios.post(`${refreshBase}/api/v1/admin/refresh`, { 'token': refreshToken }, {
            withCredentials: true,
          });

          // Get the new token from the response
          const newToken = response.data?.access_token;

          if (newToken) {
            // Store the new token in local storage
            localStorage.setItem('token', newToken);
            localStorage.setItem('userToken', newToken);

            // Update the Axios instance with the new token
            axiosInstance.defaults.headers['Authorization'] = `Bearer ${newToken}`;

            // Update the original request with the new token and retry
            originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
            return axiosInstance(originalRequest);
          } else {
            // Handle case where no new token is received
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('userToken');
            sessionStorage.removeItem('userToken');
            window.location.href = '/signin';
            return Promise.reject(error);
          }
        } catch (refreshError) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('userToken');
          sessionStorage.removeItem('userToken');
          window.location.href = '/signin';
          return Promise.reject(refreshError);
        }
      } else {
        return Promise.reject(error);
      }
    } else {
      // Handle case where error.response is not defined
      return Promise.reject(error);
    }
  }
);

export default axiosInstance;
